module.exports = __webpack_public_path__ + "h5/img/af.b24d88ac.gif";